import classNames from 'classnames'
import dayjs from 'dayjs'
import { useCookie } from 'react-use'

import { CommonMomentIcon, CommonNPayNIcon, CommonNPayPayIcon, CommonWriteIcon } from '@local/assets/icons'
import { CLICK_CODE } from '@local/utils'

import { isAfterHydrationVar } from '@web/hooks/useGlobalAfterHydration'
import useScroll from '@web/hooks/useScroll'
import Clickable from '@web/ui/components/Clickable'
import { HEIGHT_HEADER } from '@web/ui/components/Header/constant'
import Tooltip from '@web/ui/components/Tooltip'

import styles from './CheckInButton.module.scss'

interface Props {
  onClick?: () => void
}

export default function CheckInButton({ onClick }: Props) {
  const threshold = useScroll((_: number, y: number) => y > HEIGHT_HEADER)

  return (
    <div className={styles.btn_wrapper}>
      <Clickable
        className={classNames(styles.btn, { [styles.type_scrolled]: threshold })}
        onClick={onClick}
        nClickCode={CLICK_CODE[threshold ? 'my.reviewwriteiconbttn' : 'my.reviewwritebttn']}
      >
        <CommonWriteIcon className={styles.icon} aria-hidden="true" />
        <span className={styles.name}>리뷰 쓰기</span>
      </Clickable>
      {threshold && <ClipTooltip />}
    </div>
  )
}

const ClipTooltip = () => {
  const [isClosed = true, setIsClosed] = useCookie('close-clip-tooltip')

  // Hydration 이후에만 렌더링
  if (!isAfterHydrationVar()) return null

  // 노출 기간: ~ 2025.12.31 까지 노출
  const isVisible = dayjs().isBefore(dayjs('2026-01-01'))
  if (!isVisible) return null

  if (isClosed) return null

  return (
    <div className={styles.tooltip_wrapper}>
      <Tooltip
        pinStyle={{ right: 25 }}
        showAlways
        isButtonTooltip
        hasCloseButton
        pinPosition="bottom"
        onClose={() => setIsClosed('true', { expires: dayjs().endOf('month').toDate() })}
      >
        <CommonMomentIcon className={styles.icon_clip} aria-hidden="true" />
        <em className={styles.txt_clip}>클립</em> 올리고
        <CommonNPayNIcon className={styles.icon_n} aria-hidden="true" />
        <span className="place_blind">n</span>
        <CommonNPayPayIcon className={styles.icon_pay} aria-hidden="true" />
        <span className="place_blind">pay</span>
        포인트 받기
      </Tooltip>
    </div>
  )
}
